module.exports = __webpack_public_path__ + "img/nav-icon3.384a9d8c.svg";